/**
 * Request callback modal: open on "Request a callback" button click, handle form submit.
 * Submits to HubSpot Forms API (portal 7860975, form ce2ea945-3164-4eb7-a579-2203ecb47b26).
 * If submissions don't appear in HubSpot, check that form field names match in your HubSpot form.
 */
(function () {
  const MODAL_ID = 'request-callback-modal';
  const FORM_ID = 'request-callback-form';
  const BODY_INPUT_ID = 'request-callback-body';
  const SUCCESS_ID = 'request-callback-success';
  const CALLBACK_BUTTON_TEXT = 'Request a callback';
  const HUBSPOT_SUBMIT_URL = 'https://api.hsforms.com/submissions/v3/integration/submit/7860975/ce2ea945-3164-4eb7-a579-2203ecb47b26';

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function resetModalState() {
    var form = document.getElementById(FORM_ID);
    var successEl = document.getElementById(SUCCESS_ID);
    if (form) {
      form.hidden = false;
      form.reset();
    }
    if (successEl) successEl.hidden = true;
  }

  function openModal(e) {
    const modal = getModal();
    if (modal && typeof modal.showDialog === 'function') {
      e.preventDefault();
      e.stopPropagation();
      resetModalState();
      modal.showDialog();
    }
  }

  function isRequestCallbackTrigger(el) {
    if (!el || !(el instanceof HTMLElement)) return false;
    if (el.hasAttribute('data-request-callback-trigger')) return true;
    const tag = el.tagName && el.tagName.toLowerCase();
    if (tag !== 'a' && tag !== 'button') return false;
    const text = (el.textContent || '').trim();
    return text === CALLBACK_BUTTON_TEXT;
  }

  function handleDocumentClick(e) {
    const target = e.target.closest('a, button');
    if (target && target.closest('#' + MODAL_ID)) return;
    if (target && isRequestCallbackTrigger(target)) {
      openModal(e);
    }
  }

  function getFormData(form) {
    const bodyParts = [];
    const paperwork = form.querySelector('input[name="request_callback_paperwork"]:checked');
    if (paperwork) bodyParts.push('Paperwork: ' + paperwork.value);
    const postcode = form.querySelector('#request-callback-postcode');
    if (postcode && postcode.value.trim()) bodyParts.push('Postcode: ' + postcode.value.trim());
    const when = form.querySelector('input[name="request_callback_when"]:checked');
    if (when) bodyParts.push('When to call: ' + when.value);
    return bodyParts.join('\n');
  }

  function getFieldValue(form, selector) {
    var field = form.querySelector(selector);
    if (!field || typeof field.value !== 'string') return '';
    return field.value.trim();
  }

  function getPageContext() {
    var pageUri = typeof window !== 'undefined' && window.location ? window.location.href : '';
    var pageName = '';
    if (typeof window !== 'undefined' && window.location) {
      pageName = (window.location.pathname || '') + (window.location.search || '');
    }
    if (!pageName) {
      pageName = typeof document !== 'undefined' && document.title ? document.title.trim() : 'Website enquiry';
    }
    var hutk = '';
    if (typeof document !== 'undefined' && typeof document.cookie === 'string') {
      var match = document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]+)/);
      var hutkValue = match && match[1] ? match[1] : '';
      hutk = hutkValue ? decodeURIComponent(hutkValue) : '';
    }
    var context = {
      pageUri: pageUri,
      pageName: pageName
    };
    if (hutk) context.hutk = hutk;
    return context;
  }

  function buildHubSpotPayload(form) {
    var name = getFieldValue(form, '#request-callback-name');
    var email = getFieldValue(form, '#request-callback-email');
    var mobilephone = getFieldValue(form, '#request-callback-phone');
    var postcode = getFieldValue(form, '#request-callback-postcode');
    var paperwork = '';
    var paperworkEl = form.querySelector('input[name=\"request_callback_paperwork\"]:checked');
    if (paperworkEl && typeof paperworkEl.value === 'string') paperwork = paperworkEl.value;
    var speakToColleague = '';
    var whenEl = form.querySelector('input[name=\"request_callback_when\"]:checked');
    if (whenEl && typeof whenEl.value === 'string') speakToColleague = whenEl.value;

    var message = getFormData(form);
    var fields = [
      { name: 'firstname', value: name },
      { name: 'email', value: email },
      { name: 'mobilephone', value: mobilephone },
      { name: 'zip', value: postcode },
      { name: 'prio_home_page', value: paperwork },
      { name: 'speak_to_a_colleague', value: speakToColleague },
      { name: 'message', value: message }
    ];
    return {
      fields: fields,
      context: getPageContext()
    };
  }

  function showSuccess(formEl, successEl) {
    if (formEl) formEl.hidden = true;
    if (successEl) successEl.hidden = false;
  }

  function closeModalSoon(modal) {
    if (modal && typeof modal.closeDialog === 'function') {
      setTimeout(function () { modal.closeDialog(); }, 2000);
    }
  }

  function handleSubmit(e) {
    const form = document.getElementById(FORM_ID);
    const bodyInput = document.getElementById(BODY_INPUT_ID);
    const successEl = document.getElementById(SUCCESS_ID);
    const modal = getModal();

    if (!form) return;

    e.preventDefault();

    if (bodyInput && 'value' in bodyInput) bodyInput.value = getFormData(form);

    var emailValue = getFieldValue(form, '#request-callback-email');
    if (!emailValue) {
      alert('Please enter your email address.');
      return;
    }

    var payload = buildHubSpotPayload(form);

    fetch(HUBSPOT_SUBMIT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        if (res.ok) return res;
        return res.text().then(function (text) {
          throw new Error('HubSpot submission failed (' + res.status + '): ' + text);
        });
      })
      .then(function () {
        showSuccess(form, successEl);
        closeModalSoon(modal);
      })
      .catch(function (err) {
        console.error(err);
        alert('Sorry — we could not send your request. Please try again.');
      });
  }

  function init() {
    document.body.addEventListener('click', handleDocumentClick, true);

    var form = document.getElementById(FORM_ID);
    if (form) {
      form.addEventListener('submit', handleSubmit);
    }

    var modal = getModal();
    if (modal) {
      modal.addEventListener('dialog:open', resetModalState);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
